/* Support contacts (UX Revision 2f). Emails from erp.dha.go.ke (/terms, /privacy) and dha.go.ke ("Get in Touch");
   147 is the DHA helpline. */
export const supportContacts = {
  email: "support@tiberbu.health",
  helpdeskEmail: "helpdesk@dha.go.ke",
  phone: "147",
  hours: "Mon–Fri 8am–5pm",
} as const;
